import idb from "../idb";

export default {	

	async doHousekeeping(maxCacheAgeHours) {
		const db = await idb.getDb();

		return new Promise((resolve) => {
			const trans = db.transaction(["retryrequests"], "readwrite");
			trans.oncomplete = () => {
				resolve(requests);
			};

			const store = trans.objectStore("retryrequests");
			let requests = [];

			store.openCursor().onsuccess = (e) => {
				const cursor = e.target.result;
				if (cursor) {
					const minAgeMs =
						Date.now() - 1000 /* seconds */ * 60 /* minutes */ * 60 /* hours */ * maxCacheAgeHours;
					// console.log(cursor.value.timestamp, minAgeMs)
					if (cursor.value.timestamp < minAgeMs) {
						// console.log('delete!');
						cursor.delete();
					}
					cursor.continue();
				}
			};
		});
	},	


	async getRequests() {
		const db = await idb.getDb();

		return new Promise((resolve) => {
			const trans = db.transaction(["retryrequests"], "readonly");
			trans.oncomplete = () => {
				resolve(requests);
			};

			const store = trans.objectStore("retryrequests");
			let requests = [];

			store.openCursor().onsuccess = (e) => {
				const cursor = e.target.result;
				if (cursor) {
					requests.push(Object.assign(cursor.value, {key: cursor.key}));
					cursor.continue();
				}
			};
		});
	},	

	async saveRequest(request) {
		const db = await idb.getDb();

		return new Promise((resolve) => {
			const trans = db.transaction(["retryrequests"], "readwrite");
			trans.oncomplete = () => {
				resolve();
			};

			const store = trans.objectStore("retryrequests");
			request.timestamp = Date.now();
			// prevent storing it AGAIN if retry times out
			delete(request.options.retryIfOffline);
			store.put(request);
		});
	},

	async deleteRequestByKey(key) {
		const db = await idb.getDb();

		return new Promise((resolve) => {
			const trans = db.transaction(["retryrequests"], "readwrite");
			trans.oncomplete = () => {
				resolve();
			};

			const store = trans.objectStore("retryrequests");
			store.delete(key);
		});
	}


};